import React from 'react';
import { IonCardTitle, IonCardContent } from '@ionic/react';
import { validUrl } from '../utils/index';

type Props = {
  info: string,
  url: string,
  title: string,
};

const Direction: React.FC<Props> = ({ info, url, title }) => {
  if (!info && !url) {
    return (
      <IonCardContent>
        <IonCardTitle>{title}</IonCardTitle>
        <div>???</div>
      </IonCardContent>
    );
  }
  return (
    <div>
      <IonCardContent>
        <IonCardTitle>{title}</IonCardTitle>
        <div>{info}</div>
        { validUrl(url) ?
            <a href={info}>Visit weather info link</a>
          :
            <span />
        }
      </IonCardContent>
    </div>
  )
  
};

export default Direction;